'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
var _reduxPagan = require('redux-pagan');
var _reactRouter = require('react-router');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _UnsubscribePage = require('./UnsubscribePage.scss');var styles = _interopRequireWildcard(_UnsubscribePage);
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _subscriptions = require('../../redux/modules/subscriptions');
var _messageModal = require('../../redux/modules/messageModal');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Styles
var UnsubscribePage = function (_React$Component) {_inherits(UnsubscribePage, _React$Component);function UnsubscribePage() {var _temp, _this, _ret;_classCallCheck(this, UnsubscribePage);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.

























    unsubscribe = function () {var _this$props$routePara =
      _this.props.routeParams,userId = _this$props$routePara.userId,topicId = _this$props$routePara.topicId;
      _this.props.unsubscribeFromTopic({ user_id: userId, topic_id: topicId });
    }, _temp), _possibleConstructorReturn(_this, _ret);}UnsubscribePage.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {var isMessageModalOpen = nextProps.isMessageModalOpen,_nextProps$subscripti = nextProps.subscriptions,sent = _nextProps$subscripti.sent,error = _nextProps$subscripti.error;var _props$subscriptions = this.props.subscriptions,oldSent = _props$subscriptions.sent,oldError = _props$subscriptions.error;if (sent && !oldSent || error && !oldError) {var messageKey = sent ? 'successMessage' : 'errorMessage';this.props.openMessageModal({ message: _react2.default.createElement('div', { className: 'successMessage' }, _react2.default.createElement('span', null, this.props.translate('unsubscribe', messageKey))) });}if (!isMessageModalOpen && this.props.isMessageModalOpen) {_reactRouter.browserHistory.push((0, _appendLocale2.default)(this.props.locale, '/'));}};UnsubscribePage.prototype.componentWillUnmount = function componentWillUnmount() {this.props.resetSubscriptionState();};UnsubscribePage.prototype.

  render = function render() {var _props =
    this.props,translate = _props.translate,locale = _props.locale,sending = _props.subscriptions.sending;
    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.notFoundWrapper, 'pageHeight') },
        _react2.default.createElement(_reactHelmet2.default, null,
          _react2.default.createElement('meta', { name: 'robots', content: 'noindex,nofollow' })),


        _react2.default.createElement('div', { className: styles.content },
          _react2.default.createElement('div', null, translate('unsubscribe', 'message')),
          _react2.default.createElement('div', { className: styles.buttons },
            _react2.default.createElement('button', { disabled: sending, onClick: this.unsubscribe, className: 'btn btn-primary' },
              sending ?
              _react2.default.createElement('i', { className: (0, _classnames2.default)('icon icon-om-spinner om-pulse', styles.spinner) }) :
              translate('unsubscribe', 'confirm')),


            _react2.default.createElement('a', { href: (0, _appendLocale2.default)(locale, '/'), className: 'btn btn-default' }, translate('unsubscribe', 'cancel'))))));




  };return UnsubscribePage;}(_react2.default.Component);


UnsubscribePage.propTypes = {
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  routeParams: _propTypes2.default.object,
  subscriptions: _propTypes2.default.object,
  unsubscribeFromTopic: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  isMessageModalOpen: _propTypes2.default.bool,
  resetSubscriptionState: _propTypes2.default.func };


var mapDispatchToProps = {
  unsubscribeFromTopic: _subscriptions.unsubscribeFromTopic,
  openMessageModal: _messageModal.openMessageModal,
  resetSubscriptionState: _subscriptions.resetSubscriptionState };


var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    locale: state.lang.locale,
    isMobile: state.windowDimentions.isMobile,
    subscriptions: state.subscriptions,
    isMessageModalOpen: state.messageModal.isMessageModalOpen };};exports.default =


(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(
UnsubscribePage);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/UnsubscribePage/UnsubscribePage.js
// module id = 3072
// module chunks = 0